import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import Item from '../../../../models/Item';
import Button from '../../../common/Button';
import FormFeedback from '../../../common/form/FormFeedback';
import { Attributes } from '../../../../config/dataAttributesIndex';
import validationGenerator from '../../../../validationGenerator';

import './ItemForm.css';
import FormResult from '../../../../FormResult';
import ItemTabs from '../ItemTabs';

class ItemForm extends Component {
  renderForm = (formProps) => {
    const { item } = this.props;
    const {
      // values,
      // errors,
      // touched,
      // handleChange,
      // handleBlur,
      status,
      handleSubmit,
      isSubmitting,
    } = formProps;

    const saveButton = (
      <Button
        type="submit"
        label="Save Item"
        isActive={isSubmitting}
        isDisabled={isSubmitting}
        color="primary"
        handler={handleSubmit}
        className="itemForm-submitButton"
      />
    );

    return (
      <Form>
        <FormFeedback status={status} />
        <ItemTabs item={item} formProps={formProps} saveButton={saveButton} startInEditMode />
        {saveButton}
      </Form>
    );
  };

  render() {
    const { item } = this.props;

    const validationSchema = validationGenerator([
      ['itemData', Attributes.COMMON],
      ['specificData', Attributes[item.category]],
    ]);

    return (
      <div className="itemForm newItemForm">
        <Formik
          initialValues={item}
          onSubmit={(values, { setSubmitting, setStatus }) => {
            const onSuccess = () => {
              setSubmitting(false);
            };
            const onFailure = (status) => {
              setSubmitting(false);
              setStatus(new FormResult(status));
            };

            this.props.onSubmit(values, onSuccess, onFailure);
          }}
          validationSchema={validationSchema}
          render={this.renderForm}
        />
      </div>
    );
  }
}

ItemForm.propTypes = {
  item: PropTypes.instanceOf(Item).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ItemForm;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/ItemForm.jsx